import React from "react"

import { cn } from "@/modules/helpers/hooks/shared/utils"

type SkeletonProps = React.HTMLAttributes<HTMLDivElement>

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn("animate-pulse bg-gray-200 dark:bg-gray-700 rounded", className)}
      {...props}
    />
  )
}
